import MeetingMemoEmptySvg from '@/../assets/illustrations/empty-state.svg';

export const MeetingMemoEmptyIllustration = () => (
  <MeetingMemoEmptySvg testID="meeting-memo-empty-illustration" />
);
